var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FlexContainer, InlineBox, Loader, Typography } from '@rappi/rests-commons-front';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Header } from '../../commons/header/Header';
import { Stepper } from '../../commons/stepper/stepper';
import { AllyInformation } from '../../components/ally-information/ally-information';
import { COMMERCIAL_PROCESSES_CONFIG } from '../../constants/commercial-processes-config';
import { useGlobal } from '../../context/global/global.context';
import { GlobalActions } from '../../context/global/types';
import { useCommercialProcessContext } from '../../hooks/use-commercial-process-context';
import { COMMERCIAL_PROCESS_STEPS_COMPONENTS } from './constants';
import { Container, HorizontalDivider, Main } from './styles';
export const CommercialProcess = () => {
    var _a, _b;
    const navigate = useNavigate();
    const { processId = 'new' } = useParams();
    const { t } = useTranslation();
    const { state, dispatch } = useGlobal();
    const { country = 'CO', commercialProcessSelected, commercialProcessesById } = state;
    const { identificationType = '', identification = '', name: restaurantName = '', businessDetails, } = ((_a = commercialProcessesById === null || commercialProcessesById === void 0 ? void 0 : commercialProcessesById.data) === null || _a === void 0 ? void 0 : _a.business) || {};
    const { legalrepresentativename = '', legalrepresentativelastname = '', legalrepresentativeemail = '', } = businessDetails || {};
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [data, setData] = useState({});
    const [isFinalizingProcess, setIsFinalizingProcess] = useState(false);
    const { contextId, mode, status, reasons, shouldShowLoader, shouldRedirectToFinder } = useCommercialProcessContext({
        processId,
        setData,
    });
    if (shouldShowLoader) {
        return _jsx(Loader, { fullscreen: true });
    }
    if (shouldRedirectToFinder) {
        return _jsx(Navigate, { to: "/hunter-tools/commercial-processes/finder" });
    }
    const steps = (_b = commercialProcessSelected === null || commercialProcessSelected === void 0 ? void 0 : commercialProcessSelected.steps) !== null && _b !== void 0 ? _b : [];
    const sortedSteps = [...steps].toSorted((a, b) => a.index - b.index);
    const currentStep = sortedSteps.length > 0 ? sortedSteps[currentStepIndex] : null;
    const StepComponent = currentStep ? COMMERCIAL_PROCESS_STEPS_COMPONENTS[currentStep.key] : null;
    const handleFinishProcess = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsFinalizingProcess(true);
        const actionType = processId === 'new' ? 'create' : 'update';
        try {
            if (!commercialProcessSelected)
                return;
            if (!(commercialProcessesById === null || commercialProcessesById === void 0 ? void 0 : commercialProcessesById.data)) {
                throw new Error('Commercial process context not found');
            }
            if (!(commercialProcessSelected.key in COMMERCIAL_PROCESSES_CONFIG)) {
                throw new Error('Commercial process not found, please check config');
            }
            yield COMMERCIAL_PROCESSES_CONFIG[commercialProcessSelected.key].action(actionType, data, commercialProcessesById.data, contextId);
            dispatch({
                type: GlobalActions.showNotification,
                payload: {
                    type: 'success',
                    message: t(`commercialProcess.notification.${actionType}.success`),
                },
            });
            navigate('/hunter-tools/commercial-processes');
        }
        catch (_a) {
            dispatch({
                type: GlobalActions.showNotification,
                payload: {
                    type: 'error',
                    message: t(`commercialProcess.notification.${actionType}.error`),
                },
            });
        }
        finally {
            setIsFinalizingProcess(false);
        }
    });
    const openModalFinishProcess = () => {
        if (!commercialProcessSelected)
            return;
        dispatch({
            type: GlobalActions.openModalBasic,
            payload: {
                maxWidth: '370px',
                title: t('commercialProcess.modal.title'),
                body: (_jsx(FlexContainer, { direction: "column", gap: 16, children: _jsx(Typography, { component: "body", children: t('commercialProcess.modal.body') }) })),
                buttons: [
                    {
                        text: t('commercialProcess.modal.buttons.cancel'),
                        variant: 'secondary',
                        onClick: () => {
                            dispatch({
                                type: GlobalActions.hideModalBasic,
                            });
                        },
                    },
                    {
                        text: t('commercialProcess.modal.buttons.continue'),
                        variant: 'primary',
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            dispatch({
                                type: GlobalActions.hideModalBasic,
                            });
                            yield handleFinishProcess();
                        }),
                    },
                ],
            },
        });
    };
    const goNext = () => {
        if (currentStepIndex < sortedSteps.length - 1) {
            setCurrentStepIndex((i) => i + 1);
            return;
        }
        if (mode === 'only-view') {
            navigate('/hunter-tools/commercial-processes');
            return;
        }
        openModalFinishProcess();
    };
    const goBack = () => {
        if (currentStepIndex > 0) {
            setCurrentStepIndex((i) => i - 1);
            return;
        }
        if (mode === 'new') {
            navigate(`/hunter-tools/commercial-processes/finder?country=${country}&idType=${identificationType.toLowerCase()}&id=${identification}`);
            return;
        }
        navigate('/hunter-tools/commercial-processes');
    };
    const updateStepData = (data) => {
        setData((prev) => (Object.assign(Object.assign({}, prev), data)));
    };
    return (_jsxs(Container, { children: [_jsx(Header, { title: processId === 'new' ? t('commercialProcess.titleNew') : t('commercialProcess.title'), breadcrumbItems: [
                    {
                        id: 'commercial-processes',
                        label: t('commercialProcess.breadcrumb.processes'),
                        to: `/hunter-tools/commercial-processes`,
                    },
                    {
                        id: 'commercial-processes-finder',
                        label: t('commercialProcessesFinder.title'),
                        to: `/hunter-tools/commercial-processes/finder?country=${country}&idType=${identificationType.toLowerCase()}&id=${identification}`,
                    },
                    {
                        id: 'commercial-process',
                        label: commercialProcessSelected ? t(COMMERCIAL_PROCESSES_CONFIG[commercialProcessSelected.key].title) : '',
                    },
                ] }), _jsx(Main, { children: _jsxs(FlexContainer, { direction: "column", gap: 24, padding: "24px", style: { backgroundColor: '#FFFFFF', borderRadius: '8px' }, children: [_jsx(AllyInformation, { restaurantName: restaurantName, idType: identificationType, id: identification, allyName: legalrepresentativename, allyLastName: legalrepresentativelastname, email: legalrepresentativeemail }), (status === 'REJECTED' || status === 'ERROR') && (_jsxs(_Fragment, { children: [_jsx(InlineBox, { type: "error", title: t('commercialProcess.rejectionReason'), body: _jsx(FlexContainer, { direction: "column", gap: 4, margin: "8px 0 0 0", children: reasons === null || reasons === void 0 ? void 0 : reasons.map((reason) => (_jsxs(Typography, { component: "caption1", children: ["- ", reason] }, reason))) }) }), _jsx(HorizontalDivider, {})] })), _jsx(HorizontalDivider, {}), _jsx(Stepper, { currentStep: currentStepIndex + 1, steps: sortedSteps.map((step) => ({
                                title: t(`commercialProcess.steps.${step.key}.title`),
                            })) }), _jsx(HorizontalDivider, {}), currentStep && StepComponent && (_jsx(StepComponent, { step: currentStep, goNext: goNext, goBack: goBack, data: data, saveData: updateStepData, mode: mode, isFinalizingProcess: isFinalizingProcess }))] }) })] }));
};
